var React = require('react');

function Info (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M20 448h152a20 20 0 0 1 20 20v24a20 20 0 0 1-20 20H20a20 20 0 0 1-20-20v-24a20 20 0 0 1 20-20z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M96 128a64 64 0 1 0-64-64 64 64 0 0 0 64 64zm28 64H20a20 20 0 0 0-20 20v24a20 20 0 0 0 20 20h28v192h96V212a20 20 0 0 0-20-20z","className":"fa-primary","key":2})]);
}

Info.defaultProps = {"viewBox":"0 0 192 512","className":"icon"};

module.exports = Info;

Info.default = Info;
